module.exports = __webpack_public_path__ + "static/media/ted.c9e49561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ted.jpg
// module id = 405
// module chunks = 0